import React from 'react'
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer'
import UbuntuRegular from '../assets/fonts/Ubuntu/Ubuntu-Regular.ttf'
import UbuntuBold from '../assets/fonts/Ubuntu/Ubuntu-Bold.ttf'
import { useTranslation } from 'react-i18next'
import { formatDate } from '../util/format'

Font.register(
  {
    family: 'Ubuntu',
    fonts: [
      {
        src: UbuntuRegular,
        fontWeight: 400,
      },
      {
        src: UbuntuBold,
        fontWeight: 700,
      },
    ],
  },
)

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 11,
  },
  wrapper: {
    borderWidth: 1,
    borderColor: '#000',
    width: 400,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    fontFamily: 'Ubuntu',
    textDecoration: 'underline',
    marginBottom: 10,
  },
  subTitle: {
    fontWeight: 700,
    fontFamily: 'Ubuntu',
    fontSize: 13,
    marginTop: 5,
  },
  infoRow: {
    flexDirection: 'row',
    paddingVertical: 2,
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 4,
  },
  tableHeadLabel: {
    fontFamily: 'Ubuntu',
    fontWeight: 700,
    fontSize: 10,
  },
  tableColText: {
    fontFamily: 'Ubuntu',
    fontWeight: 400,
    fontSize: 10,
  },
  strong: {
    fontFamily: 'Ubuntu',
    fontWeight: 700,
  },
  col1: {
    width: '5%',
    paddingRight: 3,
  },
  col2: {
    width: '20%',
    paddingRight: 3,
  },
  col3: {
    width: '20%',
    paddingRight: 3,
  },
  col4: {
    width: '15%',
    paddingRight: 3,
  },
  col5: {
    width: '15%',
    paddingRight: 3,
  },
  col6: {
    width: '25%',
  },
  label: {
    fontFamily: 'Ubuntu',
    fontWeight: 400,
    width: 80,
  },
  value: {
    fontFamily: 'Ubuntu',
    marginBottom: 4,
  },
  footer: {
    marginTop: 30,
    fontFamily: 'Ubuntu',
  },
  footerText: {
    marginBottom: 4,
  },
})

const MaterialOrderRusDocument = ({
  data,
}) => {

  const { t } = useTranslation()

  const renderNuut = (nuut, size) => {
    if (!nuut) return <></>
    
    const nuuts = nuut.split(',')
    const sizes = size?.split('x')

    return (
      <View
        style={{
          marginBottom: 4,
          marginLeft: '5%',
          marginTop: 10,
        }}
      >
        { sizes && sizes.length > 0 && <Text style={{ width: 160, textAlign: 'center', marginBottom: 4 }}>{ sizes[1] }</Text> }
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <View
            style={{
              borderWidth: 1,
              borderColor: '#000',
              width: 160,
            }}
          >
            {
              nuuts.map((x, i) =>
                <View
                  key={`nuut-${i}`}
                  style={{
                    borderBottomWidth: i < nuuts.length - 1 ? 1 : 0,
                    borderColor: '#000',
                    height: 20,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  {
                    x.includes('*') &&
                    <View style={{ flexDirection: 'row' }}>
                      <View style={{ width: 15, height: 20, borderRightWidth: 1, borderColor: '#000' }} />
                      <View style={{ width: 10, height: 20, borderRightWidth: 1, borderColor: '#000' }} />
                      <View style={{ width: 10, height: 20, borderRightWidth: 1, borderColor: '#000' }} />
                    </View>
                  }
                  <Text style={{ flex: 1, textAlign: 'right', paddingRight: 20 }}>{ x.replace('*', '') }</Text>
                </View>
              )
            }
          </View>
          { sizes && sizes.length > 0 &&  <Text style={{ marginLeft: 4 }}>{ sizes[0] }</Text> }
        </View>
      </View>
    )
  }

  if (!data) return <></>

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation={'portrait'}>
        <View>
          <Text style={styles.title}>Multipakend Tootmine OÜ</Text>
          <Text style={styles.subTitle}>TUULIKU TEE 4C  *  TALLINN  *  10621  *  ESTONIAN REPUBLIC  *  Ph. 372 656 26 77</Text>
          <Text style={styles.subTitle}>Ph/fax 372 656 26 66  *  Mobile ph 372 56 992 902</Text>
        </View>

        <View
          style={{
            ...styles.infoRow,
            marginTop: 20,
          }}
        >
          <View style={styles.label}>
            <Text>{ `КОМУ:` }</Text>
          </View>
          {
            data && data.paperFactory ?
            <View>
              <Text style={[styles.value]}>{ data.paperFactory.FACTORY_NAME }</Text>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <Text style={{ ...styles.value, marginRight: 60 }}>{ data.paperFactory.CONTACT }</Text>
                <Text style={styles.value}>{ data.paperFactory.EMAIL }</Text>
              </View>
            </View>
            :
            <></>
          }
        </View>

        <View
          style={{
            ...styles.infoRow,
            marginTop: 20,
          }}
        >
          <View style={styles.label}>
            <Text>{ `ОТ КОГО:` }</Text>
          </View>
          {
            data && data.paperFactory ?
            <View>
              <Text style={[styles.value]}>{ `Multipakend Tootmine OÜ` }</Text>
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <Text style={{ ...styles.value, marginRight: 60 }}>{ `Irina Simonova` }</Text>
                <Text style={styles.value}>{ `info@multipakend.ee` }</Text>
              </View>
            </View>
            :
            <></>
          }
        </View>

        <View
          style={[
            styles.infoRow,
            {
              fontFamily: 'Ubuntu',
              justifyContent: 'space-between',
              fontWeight: 700,
              marginTop: 20,
            },
          ]}
        >
          <View>
            <View style={{ flexDirection: 'row' }}>
              <Text>ЗАКАЗ:</Text>
              <Text style={{ marginLeft: 40 }}>{ `${data.ORDER_NUMBER}` }</Text>
            </View>
            <Text style={{ marginLeft: 80, marginTop: 10, fontWeight: 400 }}>{ `Просим Вас изготовить гофрокартон следующих размеров` }</Text>
          </View>
          <Text>{ `ДАТА: ${formatDate(new Date(data.CREATED_DATE))}` }</Text>
        </View>

        <View>
          <View style={[styles.tableRow, { borderBottomWidth: 2, borderBottomColor: '#000', marginTop: 20 }]}>
            <View style={styles.col1}>
              <Text style={styles.tableHeadLabel}>{ t('No') }</Text>
            </View>
            <View style={styles.col2}>
              <Text style={styles.tableHeadLabel}>{ t('Размер,\nширина х длина') }</Text>
            </View>
            <View style={styles.col3}>
              <Text style={styles.tableHeadLabel}>{ t('Марка') }</Text>
            </View>
            <View style={styles.col4}>
              <Text style={styles.tableHeadLabel}>{ t('Количество') }</Text>
            </View>
            <View style={styles.col5}>
              <Text style={styles.tableHeadLabel}>{ t('Срок') }</Text>
            </View>
            <View style={styles.col6}>
              <Text style={styles.tableHeadLabel}>{ t('Примечание') }</Text>
            </View>
          </View>
          {
            data && data.orderRows.map((row, index) =>
            <View key={row.ID} style={[{ borderBottomWidth: index < data.orderRows.length - 1 ? 1 : 0, borderBottomColor: '#000' }]}>
              <View style={styles.tableRow}>
                <View style={styles.col1}>
                  <Text style={styles.tableColText}>{ index + 1 }</Text>
                </View>
                <View style={styles.col2}>
                  <Text style={styles.tableColText}>{ row.SIZE }</Text>
                  {
                    row?.SIZE_BOX ?
                    <Text style={styles.tableColText}>{ row.SIZE_BOX }</Text>
                    :
                    <></>
                  }
                </View>
                <View style={styles.col3}>
                  <Text style={styles.tableColText}>{ row.MARK }</Text>
                  {
                    row?.FSC ?
                    <Text style={styles.tableColText}>{ `FSC: ${row.FSC}` }</Text>
                    :
                    <></>
                  }
                  {
                    row?.MARK_COMMENT ?
                    <Text style={styles.tableColText}>{ `${row.MARK_COMMENT}` }</Text>
                    :
                    <></>
                  }
                </View>
                <View style={styles.col4}>
                  <Text style={styles.tableColText}>{ row.AMOUNT }</Text>
                </View>
                <View style={styles.col5}>
                  <Text style={styles.tableColText}>{ `${formatDate(new Date(row.DELIVERY_DATE))} ${row.SPEED === 1 ? '\n(ASAP)' : ''}` }</Text>
                </View>
                <View style={styles.col6}>
                  <Text style={styles.tableColText}>{ row.REMARK }</Text>
                </View>
              </View>
              { renderNuut(row.NUUT, row.SIZE) }
            </View>
            )
          }
          <View style={[styles.tableRow, { borderTopWidth: 2, borderTopColor: '#000', marginTop: 6 }]}>
            <View style={styles.col1}>
              <Text style={styles.tableHeadLabel}>{ t('No') }</Text>
            </View>
            <View style={styles.col2}>
              <Text style={styles.tableHeadLabel}>{ t('Размер,\nширина х длина') }</Text>
            </View>
            <View style={styles.col3}>
              <Text style={styles.tableHeadLabel}>{ t('Марка') }</Text>
            </View>
            <View style={styles.col4}>
              <Text style={styles.tableHeadLabel}>{ t('Количество') }</Text>
            </View>
            <View style={styles.col5}>
              <Text style={styles.tableHeadLabel}>{ t('Срок') }</Text>
            </View>
            <View style={styles.col6}>
              <Text style={styles.tableHeadLabel}>{ t('Примечание') }</Text>
            </View>
          </View>
        </View>
        <View style={styles.footer}>
          <Text
            style={{
              ...styles.strong,
            }}>
            { t('Просим дать подтверждение заказа') }
          </Text>
          <Text style={{ marginBottom: data?.REMARK ? 6 : 40, marginTop: 4 }}>{ `NB ! Просим на подтверждении заказа указать номер нашего заказа !` }</Text>
          {
            data?.REMARK ?
            <Text style={{ marginBottom: 40 }}>{ data.REMARK }</Text>
            :
            <></>
          }
          <View>
            <Text style={{...styles.footerText, marginBottom: 6}}>{ t('С уважением') }</Text>
            <Text style={styles.footerText}>{ t('Irina Guljanskaja') }</Text>
            <Text style={styles.footerText}>{ t('Multipakend Tootmine OÜ') }</Text>
            <Text style={styles.footerText}>{ t('Координатор') }</Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}

export default MaterialOrderRusDocument